import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import Medications from 'components/Patient/medications/Medications';
import PatientHistory from 'components/practice/charts/PatientHistory/PatientHistory';

import { PRACTICE_CHARTS_ACCOUNT, PRACTICE_CHARTS_CLINICAL_NOTES } from './index';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const CMS1500 = withLazyFallback(
  () => import('components/practice/BeyondBilling/Claims/CMS1500/CMS1500')
);
const Actions = withLazyFallback(() => import('components/practice/charts/Actions/Actions'));
const Appointments = withLazyFallback(
  () => import('components/practice/charts/Appointments/Appointments')
);
const PastAppointments = withLazyFallback(
  () => import('components/practice/charts/Appointments/PastAppointments')
);
const UpcomingAppointments = withLazyFallback(
  () => import('components/practice/charts/Appointments/UpcomingAppointments')
);
const CommunicationLogs = withLazyFallback(
  () => import('components/practice/charts/Communications/CommunicationLogs')
);
const CommunicationMessages = withLazyFallback(
  () => import('components/practice/charts/Communications/CommunicationMessages')
);
const Communications = withLazyFallback(
  () => import('components/practice/charts/Communications/Communications')
);
const Demographics = withLazyFallback(
  () => import('components/practice/charts/Demographics/Demographics')
);
const ChartDocuments = withLazyFallback(
  () => import('components/practice/charts/Documents/ChartDocuments')
);
const OverviewContainer = withLazyFallback(
  () => import('components/practice/charts/Overview/OverviewContainer')
);
const PatientChart = withLazyFallback(
  () => import('components/practice/charts/PatientChart/PatientChart')
);
const PatientCharts = withLazyFallback(
  () => import('components/practice/charts/PatientCharts/PatientCharts')
);
const PracticePatientSettings = withLazyFallback(
  () => import('components/practice/charts/PracticePatientSettings')
);
const SuperBillPage = withLazyFallback(
  () => import('components/practice/charts/SuperBillPage/SuperBillPage')
);
const Billing = withLazyFallback(() => import('components/practice/charts/billing/Billing'));
const BillingInvoices = withLazyFallback(
  () => import('components/practice/charts/billing/Invoices/PatientInvoices')
);
const PatientClaims = withLazyFallback(
  () => import('components/practice/charts/billing/claims/PatientClaims')
);
const Ledger = withLazyFallback(() => import('components/practice/charts/billing/ledger/Ledger'));
const BillingSuperbill = withLazyFallback(
  () => import('components/practice/charts/billing/superbill/Superbill')
);
const Transactions = withLazyFallback(
  () => import('components/practice/charts/billing/transactions/Transactions')
);

const PRACTICE_CHARTS = [
  {
    path: 'charts',
    element: <PatientCharts />,
    children: [
      {
        path: ':id',
        element: <PatientChart />,
        children: [
          { path: '', element: <OverviewContainer /> },

          ...PRACTICE_CHARTS_CLINICAL_NOTES,
          ...PRACTICE_CHARTS_ACCOUNT,

          { path: 'demographics', element: <Demographics /> },

          {
            path: 'appointments/*',
            element: <Appointments />,
            children: [
              { path: 'upcoming', element: <UpcomingAppointments /> },
              { path: 'past', element: <PastAppointments /> }
            ]
          },

          { path: 'eprescribe', element: <Actions /> },
          {
            path: 'history',
            element: <PatientHistory />,
            children: [{ path: 'medications', element: <Medications /> }]
          },
          {
            path: 'billing/*',
            element: <Billing />,
            children: [
              { path: 'ledger', element: <Ledger /> },
              {
                path: 'claims',
                element: <PatientClaims />,
                children: [{ path: ':claimId', element: <CMS1500 /> }]
              },
              { path: 'invoices', element: <BillingInvoices /> },
              {
                path: '',
                element: <Transactions />,
                children: [{ path: ':transactionId', element: <Transactions /> }]
              },
              {
                path: 'superbill',
                element: <BillingSuperbill />,
                children: [
                  { path: ':superbill', element: <SuperBillPage /> },
                  { path: 'claim/:claimId', element: <CMS1500 /> }
                ]
              },
              { path: '*', element: <NotFound /> }
            ]
          },

          { path: 'documents', element: <ChartDocuments /> },

          {
            path: 'documents/:pathId',
            element: <ChartDocuments />
          },
          {
            path: 'communications',
            element: <Communications />,
            children: [
              { path: '', element: <CommunicationMessages /> },
              { path: 'logs', element: <CommunicationLogs /> },
              { path: '*', element: <NotFound /> }
            ]
          },

          { path: 'settings', element: <PracticePatientSettings /> }
        ]
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default PRACTICE_CHARTS;
